import Urls from "../../api/endpoints";
import React, { useState, useEffect } from "react";
import LoginForm from "./parts/login/form";
import Constants from "../../constants/constants";
import { ErrorHandling } from "../../functions/index";
const Login = (props) => {
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [errorValidation, setErrorValidation] = useState(false);
  const [errorValidationMSG, setErrorValidationMSG] = useState({
    email: null,
    password: null,
  });

  const handleLogin = (e) => {
    e.preventDefault();
    if (email && password) {
      setErrorValidationMSG({
        email: null,
        password: null,
      });
      props.setShowSpinner(true);
      props.setDisableButton(true);
      let userInfo = {
        grant_type: Urls.grantType(),
        username: email,
        password: password,
      };
      var formBody = [];
      for (var property in userInfo) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(userInfo[property]);
        formBody.push(encodedKey + "=" + encodedValue);
      }
      formBody = formBody.join("&");

      fetch(Urls.login(), {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formBody,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.access_token) {
            props.setToken(data.access_token);
            localStorage.setItem('adminAccesssToken', data.access_token)
            props.setExpire(data.expires_in);
            props.setLastLogin(new Date().toLocaleString());
            props.setShowSearch(true);
            props.setLogin(true);
            props.setShowSpinner(false);
            props.setDisableButton(false);
          } else {
            setErrorValidation(true);
            setErrorValidationMSG({
              email: data.error,
              password: data.error_description,
            });
            props.setDisableButton(false);
            props.setShowSpinner(false);
          }
        })
        .catch((error) => {
          ErrorHandling(error, "login error");
        });
    } else {
      setErrorValidation(true);
      setErrorValidationMSG({
        email: !email ? Constants.EmailCannotBeEmpty : null,
        password: !password ? Constants.PasswordCannotBeEmpty : null,
      });
    }
  };
  const handleChangeEmail = (e) => {
    e.preventDefault();
    let re = /\S+@\S+\.\S+/;
    let reEmpty = /^\s*$/;
    if (!reEmpty.test(String(e.target.value).toLowerCase())) {
      if (!re.test(String(e.target.value).toLowerCase())) {
        setEmail(e.target.value);
        setErrorValidation(true);
        setErrorValidationMSG({
          email: Constants.EmailIsNotCorrect,
          password: errorValidationMSG.password,
        });
      } else {
        setEmail(e.target.value);
        setErrorValidationMSG({
          email: null,
          password: errorValidationMSG.password,
        });
      }
    } else {
      setEmail(e.target.value);
      setErrorValidationMSG({
        email: null,
        password: null,
      });
    }
  };
  const handleChangePassword = (e) => {
    e.preventDefault();
    let re = /^\s*$/;
    if (re.test(String(e.target.value))) {
      setPassword(e.target.value);
      setErrorValidation(true);
      setErrorValidationMSG({
        email: errorValidationMSG.email,
        password: Constants.PasswordCannotBeEmpty,
      });
    } else {
      setPassword(e.target.value);
      setErrorValidationMSG({
        email: errorValidationMSG.email,
        password: null,
      });
    }
  };
  return (
    <>
      <div className="login-margin"></div>
      <LoginForm
        handleLogin={handleLogin}
        showSpinner={props.showSpinner}
        handleChangeEmail={handleChangeEmail}
        errorValidationMSG={errorValidationMSG}
        handleChangePassword={handleChangePassword}
        errorValidation={errorValidation}
        disableButton={props.disableButton}
      ></LoginForm>
    </>
  );
};
export default Login;
